import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
  const { ref, isVisible } = useScrollReveal();

  return (
    <footer ref={ref} className="bg-charcoal-900 text-white">
      <div className={`max-w-6xl mx-auto px-6 md:px-8 py-16 md:py-20 ${isVisible ? 'reveal revealed' : 'reveal'}`}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mb-14">
          <div>
            <h3 className="font-heading text-2xl font-semibold tracking-tight mb-4 italic text-white">
              一緒に始めましょう
            </h3>
            <p className="text-white/50 text-sm leading-[1.8] max-w-sm mb-6 font-light">
              あなたの音楽ビジョンを形にしませんか？お気軽にご連絡ください。
            </p>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#contact');
              }}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-gold-500 text-white text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-gold-600 transition-all duration-200 rounded-full hover:shadow-[0_4px_16px_rgba(196,155,63,0.4)]"
            >
              お問い合わせ
            </a>
          </div>

          <div>
            <h4 className="text-[10px] font-semibold text-white/60 uppercase tracking-[0.25em] mb-5">Sitemap</h4>
            <ul className="flex flex-col gap-3">
              <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollTo('#home'); }} className="text-sm text-white/40 hover:text-gold-400 transition-colors duration-200 cursor-pointer font-light">HOME</a></li>
              <li><a href="#works" onClick={(e) => { e.preventDefault(); scrollTo('#works'); }} className="text-sm text-white/40 hover:text-gold-400 transition-colors duration-200 cursor-pointer font-light">WORKS</a></li>
              <li><a href="#achievements" onClick={(e) => { e.preventDefault(); scrollTo('#achievements'); }} className="text-sm text-white/40 hover:text-gold-400 transition-colors duration-200 cursor-pointer font-light">ACHIEVEMENTS</a></li>
              <li><a href="#profile" onClick={(e) => { e.preventDefault(); scrollTo('#profile'); }} className="text-sm text-white/40 hover:text-gold-400 transition-colors duration-200 cursor-pointer font-light">PROFILE</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="text-sm text-white/40 hover:text-gold-400 transition-colors duration-200 cursor-pointer font-light">CONTACT</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex items-center justify-between gap-5">
            <p className="text-white/30 text-xs font-light">
              &copy; {new Date().getFullYear()} AMERI. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/ameri_iria?igsh=MTRxbmZkaW5tNXRocg%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-gold-500 text-white/50 hover:text-white transition-all duration-200 cursor-pointer rounded-full hover:scale-110"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href="https://open.spotify.com/playlist/4NIBk1d8MZ4wqHOHlNDYLF?si=00034c16fc63458e"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-gold-500 text-white/50 hover:text-white transition-all duration-200 cursor-pointer rounded-full hover:scale-110"
              >
                <i className="ri-spotify-fill text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}